// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Overrides for Dienstpläne form fields */
.dienstplaene-form .form-group input[type="text"],
.dienstplaene-form .form-group input[type="date"],
.dienstplaene-form .form-group input[type="time"] {
  background-color: var(--mittelgruen);
  border: none;
  padding: 10px;
  border-radius: 5px;
  width: 100%;
  color: var(--dunkelgruen);
  margin-bottom: 15px;
}

.dienstplaene-form .form-group select {
  background-color: var(--mittelgruen);
  border: none;
  padding: 10px;
  border-radius: 5px;
  width: 100%;
  color: #9fb05f;
  margin-bottom: 15px;
}

.dienstplaene-form input::placeholder {
  color: #9fb05f;
  opacity: 1;
}

.form-group {
  margin-bottom: 1rem;
  text-align: left;
}

.more-strip {
  color: #00509E;
  padding: 10px 0;
  text-align: center;
}

.more-link {
  color: #00509E;
  text-decoration: underline;
  cursor: pointer;
}

.autocomplete-container {
    position: relative;
  }

  .autocomplete-list {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    max-height: 150px;
    overflow-y: auto;
    background-color: var(--hellgruen);
  }

  .autocomplete-list li {
    padding: 8px 12px;
    cursor: pointer;
  }

/* ─── Durchklickbare Dienst-Auswahl ─── */

/* Dienst-Typ: Spüldienst / Nachtwache / Freitext */
.dp-typ-row {
  display: flex;
  gap: 8px;
}

.dp-typ-btn {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 12px 8px;
  border-radius: 12px;
  border: 2px solid #0074b3;
  background-color: transparent;
  color: #0074b3;
  cursor: pointer;
  transition: all 0.15s ease;
  font-size: 0.95em;
  margin: 0;
  width: auto;
  min-height: auto;
}

.dp-typ-btn .material-symbols-outlined {
  font-size: 1.5rem;
}

.dp-typ-btn:hover {
  background-color: rgba(0, 116, 179, 0.1);
  opacity: 1;
}

.dp-typ-btn.active {
  background-color: #0074b3;
  color: #fff;
}

/* Tag-Pills (Lager-Tage) */
.dp-tag-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.dp-pill {
  flex: 0 0 auto;
  padding: 8px 14px;
  border-radius: 20px;
  border: 2px solid #0074b3;
  background-color: transparent;
  color: #0074b3;
  cursor: pointer;
  transition: all 0.15s ease;
  font-size: 0.9em;
  white-space: nowrap;
  margin: 0;
  width: auto;
  min-height: auto;
}

.dp-pill:hover {
  background-color: rgba(0, 116, 179, 0.1);
  opacity: 1;
}

.dp-pill.active {
  background-color: #0074b3;
  color: #fff;
}

/* Mahlzeit-Auswahl (Spüldienst) */
.dp-mahlzeit-row {
  display: flex;
  gap: 8px;
}

.dp-mahlzeit-btn {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 12px 8px;
  border-radius: 12px;
  border: 2px solid #0074b3;
  background-color: transparent;
  color: #0074b3;
  cursor: pointer;
  transition: all 0.15s ease;
  font-size: 0.95em;
  margin: 0;
  width: auto;
  min-height: auto;
}

.dp-mahlzeit-btn .material-symbols-outlined {
  font-size: 1.5rem;
}

.dp-mahlzeit-btn:hover {
  background-color: rgba(0, 116, 179, 0.1);
  opacity: 1;
}

.dp-mahlzeit-btn.active {
  background-color: #0074b3;
  color: #fff;
}

/* Automatisch gesetzte Uhrzeit */
.dp-uhrzeit-info {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 1rem;
  color: var(--dunkelgruen);
  font-size: 0.95em;
}

.dp-uhrzeit-info .material-symbols-outlined {
  color: #0074b3;
  font-size: 1.3rem;
}

/* Kurze Erfolgs-Bestätigung (verschwindet automatisch) */
.dp-toast {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #0074b3;
  color: #fff;
  padding: 10px 16px;
  border-radius: 10px;
  margin-bottom: 1rem;
  animation: dpToastIn 0.2s ease;
}

.dp-toast .material-symbols-outlined {
  font-size: 1.3rem;
}

@keyframes dpToastIn {
  from { opacity: 0; transform: translateY(-6px); }
  to   { opacity: 1; transform: translateY(0); }
}
`, "",{"version":3,"sources":["webpack://./src/listen/dienstplaene/DienstplaenePage.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;;;EAGE,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;IACI,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;EACpC;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;AAEF,0CAA0C;;AAE1C,mDAAmD;AACnD;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;EACjB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;EACjB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C","sourcesContent":["/* Overrides for Dienstpläne form fields */\n.dienstplaene-form .form-group input[type=\"text\"],\n.dienstplaene-form .form-group input[type=\"date\"],\n.dienstplaene-form .form-group input[type=\"time\"] {\n  background-color: var(--mittelgruen);\n  border: none;\n  padding: 10px;\n  border-radius: 5px;\n  width: 100%;\n  color: var(--dunkelgruen);\n  margin-bottom: 15px;\n}\n\n.dienstplaene-form .form-group select {\n  background-color: var(--mittelgruen);\n  border: none;\n  padding: 10px;\n  border-radius: 5px;\n  width: 100%;\n  color: #9fb05f;\n  margin-bottom: 15px;\n}\n\n.dienstplaene-form input::placeholder {\n  color: #9fb05f;\n  opacity: 1;\n}\n\n.form-group {\n  margin-bottom: 1rem;\n  text-align: left;\n}\n\n.more-strip {\n  color: #00509E;\n  padding: 10px 0;\n  text-align: center;\n}\n\n.more-link {\n  color: #00509E;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.autocomplete-container {\n    position: relative;\n  }\n\n  .autocomplete-list {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    max-height: 150px;\n    overflow-y: auto;\n    background-color: var(--hellgruen);\n  }\n\n  .autocomplete-list li {\n    padding: 8px 12px;\n    cursor: pointer;\n  }\n\n/* ─── Durchklickbare Dienst-Auswahl ─── */\n\n/* Dienst-Typ: Spüldienst / Nachtwache / Freitext */\n.dp-typ-row {\n  display: flex;\n  gap: 8px;\n}\n\n.dp-typ-btn {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  padding: 12px 8px;\n  border-radius: 12px;\n  border: 2px solid #0074b3;\n  background-color: transparent;\n  color: #0074b3;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  font-size: 0.95em;\n  margin: 0;\n  width: auto;\n  min-height: auto;\n}\n\n.dp-typ-btn .material-symbols-outlined {\n  font-size: 1.5rem;\n}\n\n.dp-typ-btn:hover {\n  background-color: rgba(0, 116, 179, 0.1);\n  opacity: 1;\n}\n\n.dp-typ-btn.active {\n  background-color: #0074b3;\n  color: #fff;\n}\n\n/* Tag-Pills (Lager-Tage) */\n.dp-tag-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.dp-pill {\n  flex: 0 0 auto;\n  padding: 8px 14px;\n  border-radius: 20px;\n  border: 2px solid #0074b3;\n  background-color: transparent;\n  color: #0074b3;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  font-size: 0.9em;\n  white-space: nowrap;\n  margin: 0;\n  width: auto;\n  min-height: auto;\n}\n\n.dp-pill:hover {\n  background-color: rgba(0, 116, 179, 0.1);\n  opacity: 1;\n}\n\n.dp-pill.active {\n  background-color: #0074b3;\n  color: #fff;\n}\n\n/* Mahlzeit-Auswahl (Spüldienst) */\n.dp-mahlzeit-row {\n  display: flex;\n  gap: 8px;\n}\n\n.dp-mahlzeit-btn {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  padding: 12px 8px;\n  border-radius: 12px;\n  border: 2px solid #0074b3;\n  background-color: transparent;\n  color: #0074b3;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  font-size: 0.95em;\n  margin: 0;\n  width: auto;\n  min-height: auto;\n}\n\n.dp-mahlzeit-btn .material-symbols-outlined {\n  font-size: 1.5rem;\n}\n\n.dp-mahlzeit-btn:hover {\n  background-color: rgba(0, 116, 179, 0.1);\n  opacity: 1;\n}\n\n.dp-mahlzeit-btn.active {\n  background-color: #0074b3;\n  color: #fff;\n}\n\n/* Automatisch gesetzte Uhrzeit */\n.dp-uhrzeit-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 1rem;\n  color: var(--dunkelgruen);\n  font-size: 0.95em;\n}\n\n.dp-uhrzeit-info .material-symbols-outlined {\n  color: #0074b3;\n  font-size: 1.3rem;\n}\n\n/* Kurze Erfolgs-Bestätigung (verschwindet automatisch) */\n.dp-toast {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: #0074b3;\n  color: #fff;\n  padding: 10px 16px;\n  border-radius: 10px;\n  margin-bottom: 1rem;\n  animation: dpToastIn 0.2s ease;\n}\n\n.dp-toast .material-symbols-outlined {\n  font-size: 1.3rem;\n}\n\n@keyframes dpToastIn {\n  from { opacity: 0; transform: translateY(-6px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
